<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-card v-if="this.currentUser !== null" class="mx-md-15">
        <v-card-title>
          <v-icon size="40" class="px-2">mdi-account-details-outline</v-icon>
          <h2 class="text-h5 font-weight-bolder" style="color: #6b6868">
            Mon profil
          </h2>
        </v-card-title>
        <v-card-text class="">
          <v-row>
            <v-col>
              <v-card class="mx-auto align-start" tile>
                <v-img
                  height="48vh"
                  width="100%"
                  src="https://picsum.photos/1920/1080?random"
                >
                  <v-row align="end" class="fill-height" style="padding: 1.5em">
                    <v-col align-self="start" class="pa-0" cols="12">
                      <v-avatar class="profile" color="grey" size="150">
                        <v-img
                          :src="
                            this.seekerPicture !== null
                              ? this.seekerPicture
                              : 'https://cdn.vuetifyjs.com/images/profiles/margfgfcus.jpg'
                          "
                        ></v-img>
                      </v-avatar>
                    </v-col>
                    <v-col class="py-0">
                      <v-list-item color="rgba(0, 0, 0, .4)" dark>
                        <v-list-item-content>
                          <v-list-item-title class="text-h5">
                            {{ this.currentUser.firstname }}
                            {{ this.currentUser.lastname }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="text-h6">
                            {{
                              this.currentUser.seeker.cvTitle === null
                                ? "-"
                                : this.currentUser.seeker.cvTitle
                            }}

                            <br />
                            <v-icon color="teal darken-2"> mdi-email</v-icon>
                            {{ this.currentUser.email }}

                            <br />
                            <v-btn-toggle
                              dense
                              background-color="primary"
                              dark
                              multiple
                            >
                              <v-btn to="/candidate/offers">
                                <v-icon>mdi-badge-account-outline</v-icon>
                                Consulter les offres
                              </v-btn>

                              <v-btn to="/candidate/cv">
                                <v-icon>mdi-file-account</v-icon>
                                Compléter mon profil
                              </v-btn>

                              <v-btn to="/candidate/my-account">
                                <v-icon>mdi-account-cog</v-icon>
                                Mon compte
                              </v-btn>
                            </v-btn-toggle>
                          </v-list-item-subtitle>
                          <v-list-item-content> </v-list-item-content>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col style="color: white">
                      <h3 style="display: block" class="text-center text-h6">
                        Votre profil complété à
                      </h3>

                      <ProfilInformationProgressCircle
                        :value="personalInformationsFilledPercentage"
                      />
                    </v-col>
                  </v-row>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row dense style="margin-top: 4em">
        <v-col cols="12" md="6">
          <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="2" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-folder-table-outline
                </v-icon>
                Mes candidatures
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Accédez à toutes mes candidatures.
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/candidate/my-applications"
                >
                  Consulter mes candidatures
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="2" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-book-account-outline
                </v-icon>
                Mes sauvegardes
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Toutes mes annonces sauvegardées.
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/candidate/saved-offers/manage"
                >
                  Voir les annonces sauvegardées
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
            <v-card color="white" dark shaped elevation="2">
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-history
                </v-icon>
                Mes recherches récentes
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Retrouvez toutes les recherches effectuées .
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/candidate/last-research/manage"
                >
                  Voir mes recherches récentes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="2" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-bell-plus-outline
                </v-icon>
                Mes alertes
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Simplifiez-vous la vie ! Recevez par email les nouvelles offres
                correspondant à vos critères.
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/candidate/alerts/manage"
                >
                  Mes alertes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6" style="margin-bottom: 6em">
          <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="2" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-folder-table-outline
                </v-icon>
                Mon CV
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Retrouvez votre Cv actuel et vos lettres de motivation
              </v-card-text>

              <v-card-actions>
                <v-btn color="deep-purple lighten-2" text to="/candidate/cv">
                  Mon Cv et mes lettres de motivation
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import ProfilInformationProgressCircle from "@/components/Candidate/ProfilInformationProgressCircle";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CandidateMyResearch",
  components: { ProfilInformationProgressCircle },
  data: function () {
    return {
      personalInformationsFilledPercentage: "0",
      currentUser: null,
      seeker: null,
      seekerPicture: null,
    };
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log(this.currentUser);

    const httpClient = new HttpClient();
    httpClient
      .getMyProfileInformationsFilledPercentage(
        localStorage.getItem("jwt-token")
      )
      .then((res) => {
        this.personalInformationsFilledPercentage =
          "" + res.data.filledPercentage;
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.$router.push("/logout");
        } else {
          alert("Une erreur s'est produite");
          console.error(err);
        }
      });

    httpClient
      .getCurrentSeeker(localStorage.getItem("jwt-token"))
      .then((res) => {
        this.seeker = res.data;
        this.seekerPicture = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/avatar/${this.seeker.account.userAvatar.fileName}`;
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.$router.push("/logout");
        } else {
          alert("Une erreur s'est produite");
          console.error(err);
        }
      });
  },
  methods: {},
});
</script>

<style scoped></style>
